import React from 'react';
import { ChevronRight, Hourglass } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

export interface PendingPersonalPlanCardV2Props {
	translate: (key: string) => string;
	/** Lleva a la vista del plan individual en proceso. */
	onOpen: () => void;
	/** Ya confirmó el plan: queda seguir el estado del alta. */
	isLocked?: boolean;
}

/**
 * Acceso al plan individual EN PROCESO desde Mi beneficio (empleado B2B de la campaña
 * de traspaso). Misma forma que `TransferNudgeV2`, sin cierre: mientras el alta siga
 * viva es su único camino, fuera del selector, hasta el plan que está abriendo.
 *
 * El copy es provisional: producto lo cierra al verlo en DEV (15/09/26).
 */
const PendingPersonalPlanCardV2: React.FC<PendingPersonalPlanCardV2Props> = ({
	translate,
	onOpen,
	isLocked = false
}) => (
	<Card className="border border-secondary/30 bg-secondary/5">
		<CardContent className="p-5">
			<div className="flex items-start gap-3 sm:gap-4">
				<div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-secondary/10 flex items-center justify-center shrink-0">
					<Hourglass className="w-5 h-5 sm:w-6 sm:h-6 text-secondary" />
				</div>
				<div className="flex-1 min-w-0">
					<div className="flex flex-wrap items-center gap-2">
						<p className="font-semibold text-sm">
							{translate('benefit.pendingPersonalPlan.title')}
						</p>
						<span
							data-testid="pending-personal-plan-badge"
							className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-medium text-amber-700"
						>
							{translate('general.avatar.pendingPersonalPlanStatus')}
						</span>
					</div>
					<p className="text-xs text-gray-500 mt-0.5">
						{translate('benefit.pendingPersonalPlan.description')}
					</p>
					<Button
						onClick={onOpen}
						className="bg-secondary hover:bg-secondary/90 text-white rounded-full text-sm gap-1 mt-3 sm:mt-2"
						size="sm"
					>
						{translate(
							isLocked ? 'benefit.pendingPersonalPlan.ctaLocked' : 'benefit.pendingPersonalPlan.cta'
						)}{' '}
						<ChevronRight className="w-4 h-4" />
					</Button>
				</div>
			</div>
		</CardContent>
	</Card>
);

export default PendingPersonalPlanCardV2;
